<template>
  <div class="wrapper d-flex flex-wrap" :class="(flash ? 'flash':'')">
    <div :class="labelClass">
      <div>{{withDecimal(price, Getter_Current_Market.priceDec)}}</div>
      <!-- <q-tooltip>{{withDecimal(price, Getter_Current_Market.priceDec)}}</q-tooltip> -->
    </div>
    <div>
      <div class="text-right">{{withDecimal(volume, Getter_Current_Market.volDec)}}</div>
      <!-- <q-tooltip>{{withDecimal(volume, Getter_Current_Market.volDec)}}</q-tooltip> -->
    </div>
    <div>
      <div>{{amount}}</div>
      <!-- <q-tooltip>{{amount}}</q-tooltip> -->
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getterTypes as getters, getterTypes } from '@/store/getter-types';
import BigNumber from 'bignumber.js';

export default {
  name: 'DepthRow',
  props: {
    label: String,
    labelClass: String,
    index: Number,
    price: String,
    propVolume: String,
    propAmount: String,
  },
  mounted() {
    this.volume = this.propVolume;
    this.amount = this.propAmount;
    this.hideFlash(800);
  },
  data() {
    return {
      volume: null,
      amount: null,
      flash: true,
    };
  },
  computed: {
    ...mapGetters([getters.Getter_Current_Market]),
  },
  methods: {
    // getIndex() {
    //   return (this.index < 10 ? '0' : '') + this.index.toString();
    // },
    // update(volume, amount) {
    //   if (!this.flash) {
    //     this.flash = true;
    //   }
    //   this.volume = volume;
    //   this.amount = amount;
    //   this.hideFlash();
    // },
    hideFlash(duration = 500) {
      setTimeout(() => {
        this.flash = false;
      }, duration);
    },
    withDecimal(value, precision) {
      return new BigNumber(value).toFixed(precision);
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: relative;
  z-index: 5;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 11.5px;
  color: #b2bfcf;
  cursor: pointer;
  transition-timing-function: ease-out;
}

.wrapper > div {
  padding-left: 5px;
  padding-right: 5px;
  width: 33.3333333333333%;
}

.wrapper > div > div:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wrapper > div:first-child {
  width: 30%;
}

.wrapper > div:nth-child(2) {
  width: 28%;
}

.wrapper > div:nth-child(3) {
  text-align: right;
  width: 42%;
}

.wrapper.flash {
  background-color: #263f52;
  transition-timing-function: ease-out;
}
</style>
